import * as React from 'react'
function SvgShieldLock(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g fill="currentColor" fillRule="evenodd">
				<path d="M22.5 15a2.5 2.5 0 10-5 0v3h5v-3z" />
				<path d="M32.33 6.028l-12-2a2.03 2.03 0 00-.66 0l-12 2A2 2 0 006 8v14c0 7.732 6.268 14 14 14s14-6.268 14-14V8a2 2 0 00-1.67-1.972zM28 26a2 2 0 01-2 2H14a2 2 0 01-2-2v-6a2 2 0 012-2h.5v-3a5.5 5.5 0 0111 0v3h.5a2 2 0 012 2v6z" />
			</g>
		</svg>
	)
}
export default SvgShieldLock
